import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import Icon from '../../Icon';

const CellIconContainer = styled.div`
  :hover {
    cursor: pointer;
  }
`;

const Cell = ({ value, onClick, ...otherProps }) => (
  <CellContainer {...otherProps}>
    <CellIconContainer onClick={() => onClick()}>
      <Icon icon={value} />
    </CellIconContainer>
  </CellContainer>
);

export default Cell;
